import {
  animate,
  state,
  style,
  transition,
  trigger,
  animation,
} from '@angular/animations';

/**
 * fadeInAnimation
 * @type {AnimationReferenceMetadata}
 */
export const fadeInAnimation = animation([
  style({ opacity: 0 }),
  animate('{{ timings }}', style({ opacity: 1 })),
]);
/**
 * fadeOutAnimation
 * @type {AnimationReferenceMetadata}
 */
export const fadeOutAnimation = animation([
  style({ opacity: 1 }),
  animate('{{ timings }}', style({ opacity: 0 })),
]);
/**
 * slideInAnimation
 * @type {AnimationReferenceMetadata}
 */
export const slideInAnimation = animation([
  style({ transform: 'translateY({{ from }})', opacity: 0 }),
  animate('{{ timings }}', style('*')),
]);
/**
 * slideOutAnimation
 * @type {AnimationReferenceMetadata}
 */
export const slideOutAnimation = animation([
  animate(
    '{{ timings }}',
    style({ transform: 'translateY({{ to }})', opacity: 0 }),
  ),
]);
/**
 * rotateAnimation
 * @type {AnimationReferenceMetadata}
 */
export const rotateAnimation = animation([
  animate(
    '{{ timings }}',
    style({ transform: 'rotate({{ rotate }})', transformOrigin: '50% 50%' }),
  ),
]);
/**
 * CollapseAnimation
 * @type {AnimationTriggerMetadata}
 */
export const CollapseAnimation = trigger('collapse', [
  state('collapsed, void', style({ height: '0px', minHeight: '0' })),
  state('expanded', style({ height: '*' })),
  transition('expanded <=> collapsed', animate('250ms ease-out')),
]);
